import { NON_FILTER_BRANCHCONDITTION_KEYS } from '../../../Common';
import { ConditionItem } from '../../../external/Common';
import { CustomerListApiRequest, SortRequest } from '../../../external/CustomerListApi';
import { ReferableAgenciesState } from '../../../interfaces/ReferableAgenciesReducer';
import { SearchConditionState } from '../../../redux/reducers/SearchConditionReducer';
import { maxItemPerPage, sortConditions } from './constants';

export const createCustomerListApiParameter = (
  crewCd: string,
  isCrewModule: boolean,
  searchConditions: SearchConditionState,
  targetStores: string[],
  targetPage: number,
  sortKey: string,
): CustomerListApiRequest => {
  const searchBranch: ConditionItem[] = [];

  // get paging info
  const paging = getPagingInfoByTargetPage(targetPage);
  // get masking flag
  const maskingFlg = isCrewModule ? '0' : '1';
  // get sort condition
  const sort: SortRequest = sortConditions.find((condition) => condition.key === sortKey) || sortConditions[0];

  // get search branch

  searchConditions.forEach((searchCondition) => {
    const isUsedInFilter = searchCondition.isUsedInFilter;
    const searchConditionName = searchCondition.searchConditionName;
    const searchConditionGroupId = searchCondition.searchConditionGroupId;
    const specifiedCondition = searchCondition.specifiedCondition;
    const isNotActionTypeWithoutInput = !isActionTypeWithNoInputCondition(searchConditionName, specifiedCondition);

    // negotiationProgressType と negotiationResultTypeのマッピングを合わせる
    if (searchConditionName === 'negotiationProgressType') {
      searchBranch.push({
        branchGroupId: searchConditionGroupId ? searchConditionGroupId : 0,
        branchConditionName: 'negotiationResultType',
        // specifiedCondition Convertingされた配列が設定される
        specifiedCondition: convertingNegotiationResultType(specifiedCondition),
      });
      return;
    }

    // 絞り込み条件画面から遷移する場合、グループ99を構成する
    if (
      isUsedInFilter &&
      searchConditionGroupId == null &&
      !NON_FILTER_BRANCHCONDITTION_KEYS.includes(searchConditionName) &&
      isNotActionTypeWithoutInput
    ) {
      // グループ99の共通の絞り込み条件に設定する。
      searchBranch.push({
        branchGroupId: 99,
        branchConditionName: searchConditionName,
        specifiedCondition: specifiedCondition,
      });
      return;
    }

    // ダッシュボード/レポート画面から遷移する場合、グループ99を構成しない
    if (isNotActionTypeWithoutInput) {
      searchBranch.push({
        branchGroupId: searchConditionGroupId ? searchConditionGroupId : 0,
        branchConditionName: searchConditionName,
        specifiedCondition: specifiedCondition,
      });
    }
  });

  return {
    userId: crewCd,
    agencyCd: targetStores,
    maskingFlg: maskingFlg,
    paging: paging,
    sort: {
      col: sort.col,
      order: sort.order,
    },
    searchBranch: searchBranch,
  };
};

/**
 * 参照可能店舗一覧取得処理
 *
 *  1 店舗フィルターが選択可能でない場合
 *    -> ログイン時に指定した取次店コード + そのコンビに該当する取次店コードを設定
 *  2 店舗フィルターが選択可能である場合(crewモジュールの場合、同一法人店舗でのログインしている、営業モジュールである場合)
 *    -> 絞り込み条件として"有効"に設定してある取次店コード一覧を設定
 *
 * @param referableAgenciesState
 * @returns
 */
export const getAgencyCdList = (referableAgenciesState: ReferableAgenciesState): string[] => {
  return referableAgenciesState.referableAgencies.size === 0
    ? referableAgenciesState.loginTargetAgencyCdList.map((v) => v.agencyCd)
    : Array.from(referableAgenciesState.referableAgencies, ([, store]) => ({ store }))

        .filter(({ store }) => store.displayOnFilterDrawer?.searchTarget)
        .map(({ store }) => store.agencyCd);
};

export const isActionTypeWithNoInputCondition = (searchConditionName: string, specifiedCondition: (string | null)[]) => {
  return searchConditionName === 'actionType' && specifiedCondition[0] === '00';
};

export const convertingNegotiationResultType = (prevSpecifiedconditions: (string | null)[]): string[] => {
  const convertSpecifiedcondition: string[] = [];

  prevSpecifiedconditions.forEach((item) => {
    convertSpecifiedcondition.push(convertCode(item));
  });

  return convertSpecifiedcondition;
};

function convertCode(item: string | null): string {
  switch (item) {
    case '01':
      return '07';
    case '02':
      return '01';
    case '03':
      return '02';
    case '04':
      return '05';
    case '05':
      return '03';
    default:
      return '00';
  }
}

export const getPagingInfoByTargetPage = (targetPage: number) => {
  return {
    maxItemPerPage: maxItemPerPage,
    from: (targetPage - 1) * maxItemPerPage + 1,
  };
};
